import React from "react";

import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon
} from "react-share";

const BUTTON_STYLE = {
  display: "inline-block",
  marginRight: 6,
  cursor: "pointer"
};

class SocialShareWidget extends React.Component {
  render() {
    let { url, title, buttonStyle, ...props } = this.props,
      finalButtonStyle = Object.assign(BUTTON_STYLE, buttonStyle),
      buttons = [
        { type: "facebook", Button: FacebookShareButton, Icon: FacebookIcon },
        { type: "twitter", Button: TwitterShareButton, Icon: TwitterIcon },
        { type: "email", Button: EmailShareButton, Icon: EmailIcon }
      ];

    if (!url) {
      url = window.location.href;
    }
    if (!title) {
      title = window.document.title;
    }

    return (
      <div {...props}>
        {buttons.map(({ type, Button, Icon }) => {
          return (
            <Button
              style={finalButtonStyle}
              key={type}
              url={url}
              title={type === "facebook" ? undefined : title}
              subject={title}
            >
              <Icon size={32} round={true} />
            </Button>
          );
        })}
      </div>
    );
  }
}

export default SocialShareWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/social-share-widget.jsx